import  { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { saveAs } from "file-saver";
import "./../../Shared/Table.css";

const Test = ({
  filters,
  setFilters,
  filteredData,
  columnVisibility,
  handleCheckboxChange,
  clearFilters,
  startingSerialNumber,
}) => {
  const [filterInputs, setFilterInputs] = useState({});
  const [activeFilterColumn, setActiveFilterColumn] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    setSelectedRows([]);
  }, [currentPage]);

  const handleRowSelection = (email) => {
    const isSelected = selectedRows.some((row) => row.email === email);
    if (isSelected) {
      setSelectedRows(selectedRows.filter((row) => row.email !== email));
    } else {
      setSelectedRows([
        ...selectedRows,
        filteredData.find((row) => row.email === email),
      ]);
    }
  };

  const handleFilterIconClick = (columnName) => {
    setActiveFilterColumn(columnName);
  };

  const handleClearFilters = () => {
    setFilterInputs({});
    setFilters({});
    setActiveFilterColumn(null);
  };

  const toggleSelectAll = () => {
    const allSelected = selectedRows.length === filteredData.length;
    const targetColumnName = activeFilterColumn;

    if (allSelected) {
      setSelectedRows([]);
    } else {
      const rowsToSelect = filteredData.map((rowData) => {
        if (filterInputs[targetColumnName]) {
          return rowData[targetColumnName]
            .toLowerCase()
            .includes(filterInputs[targetColumnName] || "");
        } else {
          return true;
        }
      });

      setSelectedRows(
        filteredData.filter((rowData, index) => rowsToSelect[index])
      );
    }
  };

  const handleCheckboxIndividualChange = (email) => {
    handleRowSelection(email);
  };

  const applyFilters = () => {
    let data = filteredData;

    for (const columnName in filters) {
      if (filters[columnName]) {
        const filterValue = (filterInputs[columnName] || "").toLowerCase();
        data = data.filter((item) =>
          item[columnName].toLowerCase().includes(filterValue)
        );
      }
    }

    return data;
  };

  const formatColumnValue = (columnName, rowData) => {
    const value = rowData[columnName];

    if (Array.isArray(value)) {
      return value.map((item) => `"${item}"`).join(";");
    } else if (value) {
      return `"${value}"`;
    }

    return "";
  };

 

  const handleDownloadEntirePage = () => {
    if (selectedRows.length === 0) {
      alert("Please select at least one row before downloading.");
      return;
    }

    const visibleColumns = Object.keys(columnVisibility).filter(
      (columnName) => columnVisibility[columnName] && columnName !== "select"
    );

    const csvData = selectedRows.map((rowData, index) => {
      const csvRow = [
        index + 1,
        ...visibleColumns.map((columnName) =>
          formatColumnValue(columnName, rowData)
        ),
      ];
      return csvRow.join(",");
    });

    const headerRow = [
      "S.No",
      ...visibleColumns.map((columnLabel) => getCustomLabel(columnLabel)),
    ];
    const csvContent = [headerRow, ...csvData].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });

    saveAs(blob, "SelectedRowsReport.csv");

    setSelectedRows([]);
  };

  const getCustomLabel = (columnName) => {
    // Define custom labels for specific columns
    const customLabels = {
      name: "Name",
      age: "Age",
      gender: "Gender",
      contactNo: "Contact Number",
      location: "Location",
      educationQualification: "Education Qualification",
      organisation: "Organization",
      designation: "Designation",
      email: "Email",
      totalExperience: "Total Experience",
      positionsSuitableFor: "Positions Suitable For",
      skills: "Skills",
      noticePeriod: "Notice Period",
      assessment: "Assessment",
      fmcgSalesExp: "FMCG Sales Experience",
      pedigree: "Pedigree",
      shortlist: "Shortlist",
      source: "Source",
      sharedOn: "Shared On",
      consultant: "Consultant",
      payroll: "Payroll",
      tradeHandled: "Trade Handled",
      businessVolume: "Business Volume",
      geographyCovered: "Geography Covered",
      nativePlace: "Native Place",
      distributorsHandled: "Distributors Handled",
      productsHandled: "Products Handled",
      accountsRetailCounters: "Accounts Retail Counters",
      teamSize: "Team Size",
      reportingTo: "Reporting To",
      monthlyTurnover: "Monthly Turnover",
      currentTotalCTC: "Current Total CTC",
      currentFixedCTC: "Current Fixed CTC",
      currentVariableCTC: "Current Variable CTC",
      ctcIncreasePercentage: "CTC Increase Percentage",
      ctcType: "CTC Type",
      calculatedCTC: "Expected CTC",
      reasonForChange: "Reason For Change",
      languagesKnown: "Languages Known",
      itLanguagesKnown: "IT Languages Known",
      databasesKnown: "Databases Known",
      softwareKnown: "Software Known",
      additionalSkills: "Additional Skills",
      linkedinProfile: "LinkedIn Profile",
      comments: "Comments",
      isNoticePeriodNegotiable: "Is Notice Period Negotiable",
    };

    return customLabels[columnName] || columnName;
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <button className="btn btn-secondary" onClick={handleClearFilters}>
            Clear Filters
          </button>
          &nbsp;&nbsp;
          <button
            className="btn btn-secondary"
            onClick={handleDownloadEntirePage}
          >
            Download
          </button>
        </div>
      </div>
      <div style={{ overflowX: "auto", maxHeight: "450px" }}>
        <table className="table table-striped table-bordered">
          <thead className="thead-dark table-primary">
            <tr className="custom-date-column">
              <th>S.No</th>
              <th>
                <label>
                  <input
                    type="checkbox"
                    checked={selectedRows.length === filteredData.length}
                    onChange={toggleSelectAll}
                  />
                  Select All
                </label>
              </th>
              {Object.keys(columnVisibility).map((columnName) => {
                if (columnVisibility[columnName]) {
                  return (
                    <th key={columnName}>
                      {columnName === "select" ? (
                        <input
                          type="checkbox"
                          checked={selectedRows.length === filteredData.length}
                          onChange={toggleSelectAll}
                        />
                      ) : (
                        <div>
                          {getCustomLabel(columnName)}
                          <FontAwesomeIcon
                            icon={faFilter}
                            onClick={() => handleFilterIconClick(columnName)}
                          />
                          {columnName === activeFilterColumn ? (
                            <input
                              type="text"
                              value={filterInputs[columnName] || ""}
                              onChange={(e) => {
                                const inputText = e.target.value || "";
                                setFilterInputs({
                                  ...filterInputs,
                                  [columnName]: inputText,
                                });
                                setFilters({
                                  ...filters,
                                  [columnName]: inputText,
                                });
                              }}
                            />
                          ) : null}
                        </div>
                      )}
                    </th>
                  );
                }
                return null;
              })}
            </tr>
          </thead>
          <tbody>
            {applyFilters().map((rowData, index) => (
              <tr key={rowData.id}>
                <td>{index + 1}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.some(
                      (row) => row.email === rowData.email
                    )}
                    onChange={() =>
                      handleCheckboxIndividualChange(rowData.email)
                    }
                  />
                </td>
                {Object.keys(columnVisibility).map((columnName) => {
                  if (columnVisibility[columnName]) {
                    return (
                      <td key={columnName}>
                        {columnName === "select" ? (
                          <input
                            type="checkbox"
                            checked={selectedRows.some(
                              (row) => row.email === rowData.email
                            )}
                            onChange={() =>
                              handleCheckboxIndividualChange(rowData.email)
                            }
                          />
                        ) : (
                          rowData[columnName]
                        )}
                      </td>
                    );
                  }
                  return null;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Test;
